export const Colors = {
    green: '#498205',
    grey: '#cccccc'
};
